export default "__VITE_ASSET__B16Hvmwe__"